@if(component){
<div class="w-12 flex flex-justify-between flex-bottom wrap">
    <div class="c-6 c-12-s c-12-m m-b-0">
        <text [content]="component"></text>
    </div>
    <!-- navigation -->
    @if(!component.displayGrid) {
    <div [class.hidden]="(component.categories?.length || 0) <= pcSlides || client.sizeId < 2"
         [style.width]="(component.categories?.length || 0) <= pcSlides || client.sizeId < 2 ? '0' : 'auto'"
         class="right">
        @if ((component.categories?.length || 0) > pcSlides) {
        <button class="m-r-3 swiper-top-arrow-button"
                [ngClass]="'cms-category-prev-' + uid"
                aria-label="Previous slide">
            <i class="icon-chevron-left  inline-flex col-w"
               aria-hidden="true"></i>
        </button>
        }
        @if ((component.categories?.length || 0) > pcSlides) {
        <button class="swiper-top-arrow-button"
                [ngClass]="'cms-category-next-' + uid"
                aria-label="Next slide">
            <i class="icon-chevron-right inline-flex col-w"
               aria-hidden="true"></i>
        </button>
        }
    </div>
    }
</div>

@switch (component.displayGrid) {
@case(true){
<div class="_grid m-t-8 wrap">
    @for(el of component.categories; track $index){
    <div class="pos-relative flex flex-column flex-justify-between">
        <ng-container *ngTemplateOutlet="elementTpl; context: { $implicit: el }"></ng-container>
    </div>
    }
</div>
}
@default {
<!-- slider -->
<carousel class="wrap default-scrollbar swiper-slide-per-view swiper-show-outside-wrap p-t-8"
          [slidesPerView]="'auto'"
          [navigation]="{
                    nextEl: '.cms-category-next-' + uid,
                    prevEl: '.cms-category-prev-' + uid
                }"
          [freeMode]="true"
          [style.--pc-slides-ceil]="pcSlidesCeil"
          [style.--pc-slides]="pcSlides"
          [style.--pc-gutter]="pcGutter"
          [scrollbar]="{ draggable: true }"
          [mousewheel]="{forceToAxis: true}"
          imageViewRoot>
    @for(slide of component.categories; track $index){
    <ng-template swiperSlide>
        <ng-container *ngTemplateOutlet="elementTpl; context: { $implicit: slide }"></ng-container>
    </ng-template>
    }
</carousel>
}
}}

<ng-template #elementTpl
             let-element>
    <div>
        <href [link]="element.link"
              class="block ratio-1-1 overflow-hidden">
            <shell></shell>
            <img [fill]="true"
                 [ratio]="1"
                 [dfImage]="element.image">
        </href>

        <div
             [ngClass]="[component.categoryTextAlign || 'left', component.textOverImage ? 'p-a pos-absolute bottom-0 left-0 right-0' : 'm-t']">
            <p class="h4"
               *iCms="'title' of element"></p>
            <p class="p2 col-11 m-t-1"
               *iCms="'subtitle' of element; skipEmpty: true"></p>
            @if (element.buttons?.length > 0 && component.displayGrid) {
            @for (button of element.buttons; track $index; let first = $first) {
            <div class="b-b b-col-5"
                 [ngClass]="first && 'b-t m-t-5'">
                <href [link]="button.link">
                    <button class="left m-t m-b s2 _custom-inline-button"
                            [inlineButton]
                            style="display: block !important; width: fit-content;">
                        <span *iCms="'buttonCopy' of button"></span>
                    </button>
                </href>
            </div>
            }
            }
            @if(element?.viewAllLink && !component.displayGrid) {
            <href [link]="element?.viewAllLink">
                <button class="m-t-2"
                        [buttonStyle]="'text-button'">{{(element?.viewAllText || 'VIEW ALL') | translate}}</button>
            </href>
            }
        </div>
    </div>
    @if(element?.viewAllLink && component.displayGrid) {
    <href [link]="element?.viewAllLink">
        <button class="m-t-5 w-12"
                [buttonStyle]="'button-1'">{{(element?.viewAllText || 'VIEW ALL') | translate}}</button>
    </href>
    }
</ng-template>
